import MainHeader from '@/components/layout/MainHeader';
import CategoryNavBar from '@/components/layout/CategoryNavBar';
import FloatingWhatsApp from '@/components/support/FloatingWhatsApp';

const CustomerLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      <MainHeader />
      <CategoryNavBar />
      <main className="flex-1 pb-16 md:pb-0">
        {children}
      </main>
      <FloatingWhatsApp />
    </div>
  );
};

export default CustomerLayout;
